import { useContext } from "react";

import {
  POST_URL_PARAM,
  POST_SIGNUP_VALUE,
} from "@every.org/common/src/entity/constants";
import {
  getRoutePath,
  ClientRouteName,
  URLFormat,
} from "@every.org/common/src/helpers/clientRoutes";

import { AuthContext } from "src/context/AuthContext";
import { AuthStatus } from "src/context/AuthContext/types";
import { useEdoRouter } from "src/hooks/useEdoRouter";
import { useUserExperiment } from "src/utility/abtesting";

export const useRedirectAfterDonateAndSignupTest = () => {
  const { search } = useEdoRouter();
  const urlSeatchParams = new URLSearchParams(search);
  const post = urlSeatchParams.get(POST_URL_PARAM);

  const authState = useContext(AuthContext);
  const loggedIn = authState.status === AuthStatus.LOGGED_IN;

  const skipGuestDonorLandingTest = !loggedIn || post !== POST_SIGNUP_VALUE;

  const guestDonorLandingTest = useUserExperiment(
    "guest_don_land",
    skipGuestDonorLandingTest
  );

  if (!loggedIn) {
    return null;
  }

  const fundAccount = guestDonorLandingTest.get<boolean>("fund_acc") ?? false;
  const history = guestDonorLandingTest.get<boolean>("history") ?? false;

  if (history) {
    return getRoutePath({
      name: ClientRouteName.MY_GIVING_HISTORY,
      format: URLFormat.RELATIVE,
    });
  }

  if (fundAccount) {
    return getRoutePath({
      name: ClientRouteName.MY_GIVING_PAYMENT,
      format: URLFormat.RELATIVE,
      query: {},
    });
  }

  return null;
};
